import _ from 'underscore';

const DEFAULT_POST_REDUCER = {
  posts: [],
  lastFetchDate: undefined
};

const postReducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_POSTS': {
      const posts = processPoiParams(action.data.items.filter(i => i));
      return { ...state, posts};
    }
    default:
      return state;
  }
};

const processPoiParams = items => {
  const poiItems = [];
  if (items && items.length > 0) {
    const grouped = _.groupBy(items, 'e_id');
    for (const key in grouped) {
      if (grouped.hasOwnProperty(key)) {
        const poiItem = getPoiDisplayTemplate();
        let weatherCoords, poiCoords, weatherTime;
        for (const ep of grouped[key]) {
          if (ep && ep.p_cl) {
            switch (ep.p_cl) {
              case 'POI':
                poiCoords = [ep.e_lat, ep.e_long]
                poiItem.info.id = ep.e_id;
                poiItem.info.class = ep.p_cl;
                poiItem.info.value = ep.v;
                poiItem.info.time = ep.p_ts;
                break;
              case 'PHOTO':
                const photoResized = `https://images.weserv.nl/?url=${ep.v}&w=`;
                poiItem.photos.push(`${photoResized}250`);
                poiItem.photosOryg.push(ep.v);
                poiItem.photosZoomBox.push(`${photoResized}900`);
                break;
              case 'COMMENT':
                poiItem.comments.push(ep.v);
                break;
              case 'WEATHER':
                weatherCoords = [ep.e_lat, ep.e_long];
                weatherTime = ep.p_ts;
                poiItem.weather[ep.p_se_id] = ep.v;
                break;
              default:
                break;
            }
        }
        }
        poiItem.info.time = poiItem.info.time ? poiItem.info.time : weatherTime;
        poiItem.coordinates = poiCoords ? poiCoords : weatherCoords;
        if (poiItem.info.id)
          poiItems.push(poiItem);
      }
    }
  }
  return poiItems;
};

const getPoiDisplayTemplate = () => ({
  coordinates: [],
  info: {},
  photos: [],
  photosOryg: [],
  photosZoomBox: [],
  comments: [],
  weather: {}
})
export { postReducer as default, DEFAULT_POST_REDUCER };
